import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ShiftSection } from './components/ShiftSection';
import { MechanismSection } from './components/MechanismSection';
import { StepsSection } from './components/StepsSection';
import { IncludedSection } from './components/IncludedSection';
import { AudienceSection } from './components/AudienceSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalSection } from './components/FinalSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-cream font-sans antialiased" data-id="element-0" data-mp="2wjqft2hhpwkj">
      <Hero data-id="element-1" data-mp="2wi5qbra193tj" />
      <main data-id="element-2" data-mp="28u5xmlt5v3cb">
        <ProblemSection data-id="element-3" data-mp="28tw9l3rof699" />
        <ShiftSection data-id="element-4" data-mp="28t4l0cwhy8sh" />
        <MechanismSection data-id="element-5" data-mp="28sbbj465l56n" />
        <StepsSection data-id="element-6" data-mp="23vcmh01cjofb" />
        <IncludedSection data-id="element-7" data-mp="23w4e5zrtp20b" />
        <AudienceSection data-id="element-8" data-mp="23utbk3a460as" />
        <OfferSection data-id="element-9" data-mp="23ti8y6semyl9" />
        <FaqSection data-id="element-10" data-mp="3ik7eyd5x05p2" />
        <FinalSection data-id="element-11" data-mp="3ikqwvtvkeu33" />
      </main>
      <Footer data-id="element-12" data-mp="3ijpcuzwkmx98" />
      <StickyCta data-id="element-13" data-mp="3ii4sg33z0up3" />
    </div>;
}